import { env } from './env';

export const oauth2Config = {
  ...env.oauth2,
  // OAuth2 endpoints (AuthKeystone spec)
  authorizationEndpoint: `${env.oauth2.serverUrl}/oauth2/authorize`,
  tokenEndpoint: `${env.oauth2.serverUrl}/oauth2/token`,
  revocationEndpoint: `${env.oauth2.serverUrl}/oauth2/revoke`,
  userinfoEndpoint: `${env.oauth2.serverUrl}/oauth2/userinfo`,
  logoutEndpoint: `${env.oauth2.serverUrl}/oauth2/logout`,
  // API v1 endpoints
  registrationEndpoint: env.oauth2.organizationId
    ? `${env.oauth2.serverUrl}/api/v1/organizations/${env.oauth2.organizationId}/users/register`
    : `${env.oauth2.serverUrl}/api/v1/users/register`,
  loginEndpoint: `${env.oauth2.serverUrl}/api/v1/users/login`,
  forgotPasswordEndpoint: `${env.oauth2.serverUrl}/api/v1/users/forgot-password`,
  resetPasswordEndpoint: `${env.oauth2.serverUrl}/api/v1/users/reset-password`,
};
